import React from 'react';
import { ShieldCheck } from 'lucide-react';
import QrCode from '../Common/QrCode';

export default function TotpEnrollForm({
  accountEmail,
  loadingSecret,
  secretGrouped,
  otpauthUri,
  code,
  setCode,
  handleConfirm,
  handleCancel,
  loading,
  error,
}) {
  return (
    <div className="space-y-5">
      <div className="text-center mb-2">
        <div className="mx-auto w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mb-3">
          <ShieldCheck className="h-6 w-6 text-blue-600" />
        </div>
        <h3 className="text-lg font-medium text-gray-900">Activa la verificación en dos pasos</h3>
        <p className="text-sm text-gray-500 mt-1">
          Por seguridad, es obligatorio activar la verificación por app antes de continuar. Solo se hace una vez.
        </p>
      </div>

      {error && (
        <div className="px-3 py-2 rounded-lg border text-sm bg-red-50 border-red-200 text-red-700">{error}</div>
      )}

      {loadingSecret ? (
        <p className="text-sm text-gray-500 text-center">Generando clave...</p>
      ) : (
        <div className="rounded-xl border border-blue-200 bg-blue-50/50 p-4">
          <div className="text-sm font-medium text-gray-900 mb-2">
            1. Abre tu app de códigos de verificación: Google Authenticator, Microsoft Authenticator, Authy, o cualquier otra similar
          </div>
          <div className="text-sm font-medium text-gray-900 mb-3">
            2. Escanea este código QR (o usa "Ingresar clave manualmente" con la clave de abajo)
          </div>
          {otpauthUri && (
            <div className="flex justify-center mb-3">
              <QrCode value={otpauthUri} />
            </div>
          )}
          <div className="text-xs text-gray-600 mb-1">Nombre de la cuenta: {accountEmail}</div>
          <div className="text-xs text-gray-600 mb-1">Clave manual (si no puedes escanear):</div>
          <div className="font-mono text-base tracking-widest bg-white border rounded-lg px-3 py-2 mb-3 select-all break-all">
            {secretGrouped}
          </div>
          <div className="text-sm font-medium text-gray-900 mb-2">
            3. Ingresa aquí el código de 6 dígitos que aparece en la app
          </div>
          <form onSubmit={handleConfirm} className="space-y-3">
            <input
              type="text"
              value={code}
              onChange={(e) => setCode(e.target.value.replace(/[^0-9]/g, '').slice(0, 6))}
              maxLength={6}
              placeholder="000000"
              className="block w-full px-4 py-3 text-center text-2xl tracking-widest border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
              autoFocus
              required
            />
            <button
              type="submit"
              disabled={loading || code.length !== 6}
              className="w-full text-white py-3 px-4 rounded-lg font-semibold disabled:opacity-70 disabled:cursor-not-allowed"
              style={{ backgroundColor: '#776F74' }}
            >
              {loading ? 'Verificando...' : 'Confirmar y activar'}
            </button>
            <button
              type="button"
              onClick={handleCancel}
              className="w-full flex items-center justify-center text-sm text-gray-600 hover:text-gray-900 py-2"
            >
              Volver al inicio de sesión
            </button>
          </form>
        </div>
      )}
    </div>
  );
}
